import * as React from 'react';
import Cached from 'material-ui/svg-icons/action/cached';
import Dictionary from '@inqool/uas-web-core/es/components/app/Dictionary';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import { compose, withProps, onlyUpdateForKeys, setDisplayName } from 'recompose';
import { withRouter } from 'react-router-dom';

import { withClassname } from '@components/hoc/withClassname';

import { WantedPersonsForm } from '@modules/wantedPersons/WantedPersonsForm';
import { withAdditionalProps } from '@components/hoc/withAdditionalProps';
import { withColumns } from '@components/hoc/withColumns';
import { Agenda } from '@modules/columnSettings/_columnSettingsEnums';
import { ColumnManager } from '@modules/columnSettings/ColumnManager';

export const wantedPersonUrl = '/metropolis/api/wp/people';
export const wantedPersonLabel = 'Hledaní lidé';
export const wantedPersonPath = '/wanted/persons';
export const wantedPersonGridName = 'module-person';
export const WantedPersonsGrid = compose<any, any>(
  withRouter,
  setDisplayName('WantedPersonsGrid'),
  onlyUpdateForKeys(['url', 'location']),
  breadcrumbs([{ label: wantedPersonLabel }]),
  withColumns(Agenda.WANTED_PERSONS),
  withProps(({ columns }) => ({
    name: 'module-person',
    url: wantedPersonUrl,
    Form: WantedPersonsForm,
    dialog: false,
    gridProps: {
      deleteFiltersTooltip: 'Reset filtrů',
      deleteFiltersIcon: <Cached />,
      columns,
      ActionBar: () => <ColumnManager agenda={Agenda.WANTED_PERSONS} />,
      filterRow: true,
      showCheckboxes: true,
      deleting: true,
      filtering: false,
      locale: 'cz',
      adding: true,
      pageSize: 50,
      version: 11
    }
  })),
  withAdditionalProps,
  withClassname({ className: 'mp-grid' })
)(Dictionary);



// WEBPACK FOOTER //
// ./src/modules/wantedPersons/WantedPersonsGrid.tsx